import { useContext } from "react"
import { MobXProviderContext } from "mobx-react"

export default function useInjectStore() {
  return useContext(MobXProviderContext)
}
